export default __webpack_public_path__ + "static/miceBanner_2560-0e2299e0b1a44014e624c2987bfdb9aa.jpg";